export const iconFontAwesomeMovingCaravan = (
	<i className="fa-solid fa-caravan"></i>
);
